module.exports = __webpack_public_path__ + "static/5HOVER-1c39d3e0489f2025c995b818ad9ce552.png";